import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { JiraConfigService } from './jira-config.service';

@Component({
  selector: 'app-jira-config',
  templateUrl: './jira-config.component.html',
  styleUrls: ['./jira-config.component.less']
})
export class JiraConfigComponent implements OnInit {

  moduleDetails: any = {};
  moduleType;
  jiraDefect: any = {};

  constructor(private route: ActivatedRoute, private AuthService: AuthenticationService, private jiraConfigService: JiraConfigService) { }

  ngOnInit() {
    this.route.params.subscribe(() => {
      this.moduleType = this.route.snapshot.data['type'];
      this.moduleDetails = this.route.snapshot.data['details'].response;
      this.AuthService.getUserRoleByProject(this.moduleDetails.role); /* Role */

      this.getActiveDefect();

    });
  }

  getActiveDefect() {
    this.jiraConfigService.activeDefect(this.moduleDetails.id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.jiraDefect = data.response;
      }
    });
  }

}
